import { degToRad, radToDeg } from "@evergis/sgis/es/utils/math";
import { compose } from "redux";

import { ClassificationParameter } from "../../interfaces/classification";
import { SYMBOL_LIMITS } from "../SymbolEditor/limits";
import { i18n } from "../../i18n";
import { ParameterInfo, Units } from "./types";

const DEFAULT_PARAMETER_INFO: ParameterInfo = {
  classifyAble: true,
  min: SYMBOL_LIMITS.STROKE_WIDTH_MIN,
  max: SYMBOL_LIMITS.STROKE_WIDTH_MAX,
  step: SYMBOL_LIMITS.STROKE_WIDTH_STEP,
  units: Units.Pixels,
  serialize: value => value,
  deserialize: value => value,
};

const PARAMETER_INFOS: Partial<Record<ClassificationParameter, ParameterInfo>> = {
  size: {
    ...DEFAULT_PARAMETER_INFO,
    min: SYMBOL_LIMITS.SIZE_MIN,
    max: SYMBOL_LIMITS.SIZE_MAX,
    step: SYMBOL_LIMITS.SIZE_STEP,
    units: Units.Pixels,
  },
  gridSize: {
    ...DEFAULT_PARAMETER_INFO,
    min: SYMBOL_LIMITS.GRID_SIZE_MIN,
    max: SYMBOL_LIMITS.GRID_SIZE_MAX,
    step: SYMBOL_LIMITS.SIZE_STEP,
    classifyAble: false,
    units: null,
  },
  maxObjectCount: {
    ...DEFAULT_PARAMETER_INFO,
    min: SYMBOL_LIMITS.MIN_OBJECTS_COUNT,
    max: SYMBOL_LIMITS.MAX_OBJECTS_COUNT,
    step: SYMBOL_LIMITS.SIZE_STEP,
    classifyAble: false,
    units: i18n.t(Units.Count, { ns: "common" }),
  },
  selectionObjectsLimit: {
    ...DEFAULT_PARAMETER_INFO,
    min: SYMBOL_LIMITS.MIN_OBJECTS_COUNT,
    max: SYMBOL_LIMITS.MAX_OBJECTS_COUNT,
    step: SYMBOL_LIMITS.SIZE_STEP,
    classifyAble: false,
    units: i18n.t(Units.Count, { ns: "common" }),
  },
  angle: {
    ...DEFAULT_PARAMETER_INFO,
    min: SYMBOL_LIMITS.ANGLE_MIN,
    max: SYMBOL_LIMITS.ANGLE_MAX,
    step: SYMBOL_LIMITS.ANGLE_STEP,
    units: Units.Degrees,
    serialize: compose(Math.round, radToDeg),
    deserialize: degToRad,
  },
  endingSize: {
    ...DEFAULT_PARAMETER_INFO,
    classifyAble: false,
    min: 3,
    max: 12,
    step: 1,
  },
};

export const getSymbolParameterInfo = (parameter: ClassificationParameter): ParameterInfo => {
  return PARAMETER_INFOS[parameter] || DEFAULT_PARAMETER_INFO;
};
